// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","submit":"styles_submit__K7iBZ","form":"styles_form__uTwe3"};